"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var ConfigContext_1 = require("../contexts/ConfigContext");
var WidgetCard = function (props) {
    var handleStageChange = props.handleStageChange, organization = props.organization, organizationLoading = props.organizationLoading, organizationError = props.organizationError, stage = props.stage;
    var translations = hooks_1.useContext(ConfigContext_1.default).translations;
    var renderBackButton = function () {
        if (stage === 2) {
            return (preact_1.h("button", { className: "px-1 text-sm text-gray-600 bg-transparent hover:bg-gray-200 rounded-md", onClick: function () { return handleStageChange(1); } }, "\u2190"));
        }
        else {
            return (preact_1.h(preact_1.Fragment, null, organization ? (preact_1.h("a", { target: "_blank", href: organization.changelogs_url, className: "text-primary hover:underline" },
                translations.allUpdatesLinkText,
                " \u2197")) : null));
        }
    };
    var renderBrand = function () {
        var _a = organization.display_branded_content, display_branded_content = _a === void 0 ? false : _a;
        if (display_branded_content) {
            return (preact_1.h("a", { href: "https://www.hellonext.co", target: "_blank", className: "hover:text-primary" }, "\u26A1\uFE0F by Hellonext"));
        }
        return null;
    };
    var renderOrganizationError = function () {
        return (preact_1.h("p", { className: "my-10 text-center text-red-700" }, organizationError));
    };
    var renderLoading = function () {
        return (preact_1.h("div", { className: "flex items-center justify-center w-full h-full" },
            preact_1.h("svg", { class: "animate-spin h-5 w-5 text-primary", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24" },
                preact_1.h("circle", { class: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", "stroke-width": "4" }),
                preact_1.h("path", { class: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" }))));
    };
    var renderContent = function () {
        return (preact_1.h(preact_1.Fragment, null,
            preact_1.h("div", { className: "relative flex justify-between items-center px-3 py-2.5 text-xs font-medium text-gray-700 bg-gray-50 border-b border-gray-100 h-10" },
                preact_1.h("div", null, renderBackButton()),
                renderBrand()),
            preact_1.h("div", { className: "flex-1 overflow-y-auto overflow-x-auto" }, props.children)));
    };
    var renderCard = function () {
        if (!organization && organizationLoading)
            return renderLoading();
        if (organizationError)
            return renderOrganizationError();
        if (organization)
            return renderContent();
    };
    return (preact_1.h("div", { className: "flex flex-col w-full h-full overflow-hidden bg-white rounded shadow-sm relative" }, renderCard()));
};
exports.default = WidgetCard;
